<template>
</template>

<script>
export default {
    name : 'TicketWidgetJS',

    props : ['widget'],

    mounted() {
      if ( !this.widget || !this.widget.parameter ) {
        console.log('#12 TicketWidgetJS mounted', this.widget, this);
        return;
      }

      var _script = document.createElement("script");
      _script.innerHTML = this.widget.parameter;
      document.body.appendChild( _script );
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetJS.vue